import { Breadcrumbs } from "@hatch-digital-nl/bravilor-storybook";
import { JSX } from "react";
import { CartHeaderWidget } from "../../cartPage/components/CartHeaderWidget";
import { useStringTranslation } from "../../../common/hooks/useStringTranslation";

export const Header = (): JSX.Element => {
    const { t, isLoading: translationsIsLoading } = useStringTranslation();

    return (
        <div className={"p-refurbished__header"}>
            <Breadcrumbs
                isLoading={translationsIsLoading}
                className="p-refurbished__breadcrumbs"
                items={[
                    {
                        label: t("refurbished"),
                    },
                ]}
            />
            <CartHeaderWidget />
        </div>
    );
};
